const list = {
  // =================================================================================================================
  components() {
    return [
      {
        'component': 'search-year',
        "label": '연도',
        "value": 'year',
        "query": {'y': 'year'},
        "options": {
          default: new Date().getFullYear(),
          afterFix: '년',
        }
      },
    ]
  },

  getConditions: (nav) => {
    const conditions = [];
    const search = nav.value;

    if (search.year) {
      conditions.push({ key: 'body.연도', operator: '=', value: `${search.year}` })
    }

    return conditions;
  },

  // =================================================================================================================
  getHead: () => {
    return [
      { name: "연도",        key: "body.연도" },
      { name: "사업장별 Cap 점수", key: "" },
      { name: "작성일",      key: "created_at" },
    ];
  },

  getCol: (index, value, func) => {
    try {
      const body = func.getContent(value);
      let i = 0;
      if (index === i++) return body.연도 || '';
      if (index === i++) {
        const capList = body.capList || [];
        return capList
          .filter((item) => item.사업장명)
          .map((item) => `${item.사업장명} : ${item.점수 === '' || item.점수 === null || item.점수 === undefined ? '-' : item.점수}점`)
          .join(', ');
      }
      if (index === i++) return (value.created_at || '').substring(0, 10);
    } catch (e) {
      /* ignore */
    }
    return '';
  },

  getSearchKeyValue: () => {},
  getSearchKeyword: () => {},
}

export default list;
